import { useSelector } from 'react-redux';
import WelcomeForm from '../pages/Promoter/WelcomeForm';
import EndProcess from '../pages/Promoter/EndProcess';
import Promoter from '../pages/Promoter/Promoter';
import { selectConfig } from '../redux/selectors';
import GenericError from '../components/GenericError';
import AddressValidation from '../pages/Referral/AddressValidation';
import PersonalData from '../pages/Referral/PersonalData';
import EndReferralProcess from '../pages/Referral/EndReferralProcess';
import SelectDocumentTypeScreen from '../pages/Referral/SelectDocumentTypeScreen';
import ValidateCoverage from '../pages/Referral/ValidateCoverage';
import ValidateIdu from '../pages/Referral/ValidateIdu';
import { EnProgresoSVG, SuccessfulProcessSVG, AlertProcessSVG, SinInformacionSVG, ErrorGenericSVG } from 'common-ui-components';
import CheckStatusScreen from '../pages/Promoter/CheckStatusScreen';
import { ReactComponent as NotAvailable } from '../assets/images/not-available.svg';
import { ReactComponent as EmptyState } from '../assets/images/empty-state.svg';
import { ReactComponent as SandClock } from '../assets/images/sand-clock.svg';

const useNavigationRoutes = () => {
  const { language } = useSelector(selectConfig);

  const SCREEN_MAP = {
    // Promoter Screens
    Promoter: {
      component: <Promoter />,
      showHeader: true,
      modalTitle: language.promoter.firstScreen.header,
    },
    EndProcess: {
      component: <EndProcess />,
      showHeader: true,
      modalTitle: language.promoter.finalScreen.title,
    },
    WelcomeForm: {
      component: <WelcomeForm />,
      showHeader: true,
    },
    CantRefferNewClientsError: {
      component: <GenericError text={language.cantRefferNewClients} targetScreen='Promoter' />,
      showHeader: true,
      isError: true,
    },
    InvitationExpired: {
      component: <GenericError text={language.invitationExpired} icon={<SandClock />} />,
      showHeader: true,
      isError: true,
    },
    CheckStatusService: {
      component: <CheckStatusScreen />,
      showHeader: true,
    },
    ProcessingApplication: {
      component: <GenericError text={language.processingApplication} targetScreen='Promoter' icon={<EnProgresoSVG transparent style={{ height: '150px' }} />} />,
      showHeader: true,
      isError: true,
    },
    ServiceSuccess: {
      component: <GenericError text={language.serviceSuccess} targetScreen='Promoter' icon={<SuccessfulProcessSVG transparent style={{ height: '150px' }} />} />,
      showHeader: true,
      isError: true,
    },
    CancelledApplication: {
      component: <GenericError text={language.cancelledApplication} targetScreen='Promoter' />,
      showHeader: true,
      isError: true,
    },
    InvalidApplicationNumber: {
      component: <GenericError text={language.invalidApplicationNumber} targetScreen='Promoter' icon={<AlertProcessSVG transparent style={{ height: '150px' }} />} />,
      showHeader: true,
      isError: true,
    },
    // Referral Screens
    ValidateIdu: {
      component: <ValidateIdu />,
    },
    DocumentTypeSelection: {
      component: <SelectDocumentTypeScreen />,
      showHeader: true,
      modalTitle: language.selectDocumentTypeScreen.header,
    },
    ValidateCoverage: {
      component: <ValidateCoverage />,
      showHeader: true,
    },
    AddressValidation: {
      component: <AddressValidation />,
      showHeader: true,
    },
    PersonalData: {
      component: <PersonalData />,
      showHeader: true,
    },
    EndReferralProcess: {
      component: <EndReferralProcess />,
      showHeader: true,
      modalTitle: language.referral.endProcess.title,
      isModalWhiteSpaceNormal: true,
    },

    // Error Screens
    NoCoverageError: {
      component: (
        <GenericError text={language.noCoverageError} targetScreen='ValidateIdu' />
      ),
      showHeader: true,
      isError: true,
    },
    InvalidLinkError: {
      component: <GenericError text={language.invalidLink} icon={<NotAvailable />} />,
      showHeader: true,
      isError: true,
    },
    FinishedReferralError: {
      component: <GenericError text={language.finishedReferral} icon={<EmptyState />} />,
      showHeader: true,
      isError: true,
    },
    InvitationAlreadyUsedError: {
      component: <GenericError text={language.invitationAlreadyUsed} icon={<AlertProcessSVG transparent />} />,
      showHeader: true,
      isError: true,
    },
    InvitationCancelledError: {
      component: <GenericError text={language.invitationCancelled} />,
      showHeader: true,
      isError: true,
    },
    CantParticipateError: {
      component: <GenericError text={language.cantParticipate} targetScreen='ValidateIdu' />,
      showHeader: true,
      isError: true,
    },
    NotMeetingRequirementsError: {
      component: <GenericError text={language.notMeetingRequirements} targetScreen='Promoter' icon={<ErrorGenericSVG transparent style={{ scale: '0.8' }} />} />,
      showHeader: true,
      isError: true,
    },
    NotMeetingRequirementsErrorRef: {
      component: <GenericError text={language.notMeetingRequirementsRef} targetScreen='ValidateIdu' icon={<SinInformacionSVG transparent style={{ height: '150px' }} />} />,
      showHeader: true,
      isError: true,
    },
    AlreadyProcessingReferralErrorRef: {
      component: <GenericError text={language.alreadyProcessingReferralErrorRef} targetScreen='ValidateIdu' icon={<AlertProcessSVG transparent style={{ height: '150px' }} />} />,
      showHeader: true,
      isError: true,
    },
    NoActiveServiceError: {
      component: <GenericError text={language.noActiveService} targetScreen='Promoter' icon={<ErrorGenericSVG transparent style={{ scale: '0.8' }} />} />,
      showHeader: true,
      isError: true,
    },
    VerifyDataError: {
      component: <GenericError text={language.verifyData} targetScreen='Promoter' icon={<SinInformacionSVG transparent noMargin />} />,
      showHeader: true,
      isError: true,
    },
    UnexpectedError: {
      component: <GenericError text={language.unexpectedError} />,
      showHeader: true,
      isError: true,
    },
  };

  return { SCREEN_MAP };
};

export default useNavigationRoutes;
